import React from "react";
import PropTypes from "prop-types";
// Material imports
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Button from "@mui/material/Button";
import makeStyles from "@mui/styles/makeStyles";
import { useTheme } from "@mui/material/styles";
// Limitless imports
import HelpPage from "../help-page/HelpPage";
import Circle from "@limitless/icons/Circle";
import CheckCircle from "@limitless/icons/CheckCircle";
import ExpandMoreIcon from "@limitless/icons/AngleDown";
const useStyles = makeStyles(theme => ({
  chapter: {
    padding: "0 16px 12px"
  },
  chapterHead: {
    position: "relative"
  },
  chapterTitle: {
    marginLeft: "28px !important",
    "&:before": {
      content: "''",
      textAlign: "center",
      width: 14,
      height: 14,
      borderRadius: "50%",
      border: `2px solid ${theme.palette.secondary.main}`,
      display: "inline-block",
      position: "absolute",
      left: -28,
      top: 1
    }
  },
  chapterTitleComplete: {
    marginLeft: "28px !important",
    position: "relative",
    "&:before": {
      content: "''",
      textAlign: "center",
      width: 18,
      height: 18,
      borderRadius: "50%",
      backgroundColor: theme.palette.secondary.main,
      display: "inline-block",
      position: "absolute",
      left: -28,
      top: 1
    },
    "&:after": {
      content: "''",
      display: "inline-block",
      transform: "rotate(45deg)",
      height: 8,
      width: 4,
      borderBottom: "2px solid #fff",
      borderRight: "2px solid #fff",
      position: "absolute",
      top: 4,
      left: -22
    }
  },
  pageButton: {
    marginLeft: 8,
    marginRight: 8,
    marginTop: 16,
    fontWeight: 400
  },
  accordionHeader: {},
  accordionRounded: {
    padding: "4px 0",
    boxShadow: "0px 1px 7px -3px rgba(0,0,0,0.25)",
    "&:first-child": {
      borderTopLeftRadius: 8,
      borderTopRightRadius: 8
    },
    "&:last-child": {
      borderBottomLeftRadius: 8,
      borderBottomRightRadius: 8
    }
  },
  accordianRoot: {
    color: theme.palette.primary.dark
  },
  sectionTitleContainer: {
    marginTop: 16,
    marginBottom: 14
  },
  guideSectionTitle: {
    marginLeft: 16,
    marginBottom: 12,
    marginTop: 4
  }
}));
const HelpGuide = ({
  t,
  guideHook,
  sections
}) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const theme = useTheme();
  const {
    updateActivePage
  } = guideHook;
  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const renderPageButtons = (currentIndex, sectionIndex) => {
    var _sections$sectionInde;
    if (((_sections$sectionInde = sections[sectionIndex].chapters[currentIndex]) === null || _sections$sectionInde === void 0 ? void 0 : _sections$sectionInde.pages.length) > 0) {
      var _sections$sectionInde2, _sections$sectionInde3, _sections$sectionInde4;
      return /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        justifyContent: "center"
      }, ((_sections$sectionInde2 = sections[sectionIndex].chapters[currentIndex]) === null || _sections$sectionInde2 === void 0 ? void 0 : _sections$sectionInde2.activePage) !== 0 && /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: () => updateActivePage(sectionIndex, currentIndex, -1),
        className: classes.pageButton,
        color: "primary",
        size: "small",
        variant: "contained",
        id: "backHelpGuide"
      }, t("Back"))), ((_sections$sectionInde3 = sections[sectionIndex].chapters[currentIndex]) === null || _sections$sectionInde3 === void 0 ? void 0 : _sections$sectionInde3.activePage) !== ((_sections$sectionInde4 = sections[sectionIndex].chapters[currentIndex]) === null || _sections$sectionInde4 === void 0 ? void 0 : _sections$sectionInde4.pages.length) - 1 && /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: () => updateActivePage(sectionIndex, currentIndex, 1),
        className: classes.pageButton,
        color: "primary",
        size: "small",
        variant: "contained",
        id: "nextHelpGuide"
      }, t("Next")))));
    }
    return null;
  };
  return /*#__PURE__*/React.createElement(Grid, null, sections === null || sections === void 0 ? void 0 : sections.map((sectionsData, sectionIndex) => {
    return /*#__PURE__*/React.createElement(Grid, {
      key: sectionIndex
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      key: sectionIndex,
      className: classes.sectionTitleContainer
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      color: "textPrimary",
      className: classes.guideSectionTitle
    }, sectionsData.title)), sectionsData === null || sectionsData === void 0 ? void 0 : sectionsData.chapters.map((chapter, chapterindex) => {
      return /*#__PURE__*/React.createElement(Grid, {
        key: chapter.id,
        item: true,
        className: classes.chapter
      }, /*#__PURE__*/React.createElement(Accordion, {
        expanded: expanded === `${chapter.id}${sectionIndex}`,
        onChange: handleChange(`${chapter.id}${sectionIndex}`),
        classes: {
          rounded: classes.accordionRounded,
          root: classes.accordianRoot
        }
      }, /*#__PURE__*/React.createElement(AccordionSummary, {
        expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
          color: theme.palette.secondary.main
        }),
        "aria-label": "Expand",
        "aria-controls": "additional-actions1-content",
        id: "additional-actions1-header",
        className: classes.accordionHeader,
        classes: {
          expandIconWrapper: classes.accordianRoot
        }
      }, chapter.activePage !== chapter.pages.length - 1 ? /*#__PURE__*/React.createElement(Circle, {
        size: 16,
        style: {
          marginRight: 16
        },
        color: theme.palette.secondary.main
      }) : /*#__PURE__*/React.createElement(CheckCircle, {
        size: 16,
        style: {
          marginRight: 16
        },
        color: theme.palette.secondary.main
      }), /*#__PURE__*/React.createElement(Typography, {
        variant: "body2",
        display: "inline",
        classes: {
          displayInline: classes.chapterHead
        }
      }, chapter.title)), /*#__PURE__*/React.createElement(AccordionDetails, null, /*#__PURE__*/React.createElement(React.Fragment, null, chapter.pages.map((page, index) => {
        return chapter.activePage === index && /*#__PURE__*/React.createElement(HelpPage, {
          key: index,
          page: page,
          dots: chapter.pages.map((page, index) => chapter.activePage === index ? 1 : 0),
          pageButtons: renderPageButtons(chapterindex, sectionIndex)
        });
      })))));
    }));
  }));
};
HelpGuide.propTypes = {
  guideHook: PropTypes.object,
  sections: PropTypes.array,
  t: PropTypes.func.isRequired
};
export default HelpGuide;